import axios from 'axios';
import apiConfig from '../api.config';

export default function doorOpeningHotels() {
  const {
    host,
    URIs: { doorOpeningHotels },
  } = apiConfig;

  const uri = `${host}${doorOpeningHotels}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
